/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-10 13:15:23
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 21:56:01
 * @FilePath: /wemeet-web-activity/src/pages/tickets/hooks/useCouponList.ts
 * @Description: 优惠券列表获取和选择对应的优惠券
 */
import { useEffect, useMemo, useState } from 'react';
import PublicCouponQueryPublicList from "../../quickServices/PublicCouponQueryPublicList";
import buyerCoupon from "../../Coupon/modal/buyer-coupon";
// import { ThemeContext } from '../context';

const useCouponList = (eventId, ticket, couponList, http) => {
  // const { http } = useContext(ThemeContext);
  const {
    coupons,
    coupon
  } = buyerCoupon.setCouponList(couponList || []);
  const [canPayCoupon, setCanPayCoupon] = useState();
  const [unUseList, canUseList] = useMemo(() => {
    const unUse = [];
    const canUse = [];
    buyerCoupon.getCanUseToBuyCoupons().forEach(item => {
      if ((item.threshold || 0) > (ticket?.discount_price || 0)) {
        unUse.push(item);
      } else {
        canUse.push(item);
      }
    });
    return [unUse, canUse];
  }, [coupons, ticket]);
  useEffect(() => {
    if (!couponList && http) {
      // 没有传入列表时候，就自己拉新的
      PublicCouponQueryPublicList({
        event_id: eventId
      }, http).then(res => {
        if (res.code === 0) {
          // 只显示已经领取的
          // @ts-ignore
          const couponList = buyerCoupon.transformCoupons(res.data.coupons); // 统一格式化下
          // const showCoupons: any = couponList.filter(item => item.user_coupon_state === 1);
          buyerCoupon.updateCouponList(couponList);
          // buyerCoupon.setAllCoupons(couponList);
        }
      });
    }
  }, [http]);

  // 选择的票变化时候，更新下选中的优惠券
  // 如果选中的优惠券不合适，就选择一个合适的已经领取的优惠券
  useEffect(() => {
    if (ticket?.ticket_id) {
      const tPrice = ticket.discount_price || 0;
      if (!coupon || coupon && tPrice < (coupon.threshold || 0)) {
        // 当前选中的优惠券不符合规则，选择一个已领取的最优惠的优惠券
        const suitCoupon = buyerCoupon.getSuitableCoupon(tPrice, canUseList);
        buyerCoupon.updateSelectCoupon(suitCoupon);
        // 如果没有可选中的优惠券的话，就看下有没有其他券适用的，有的话就出现领券的东西
        if (!suitCoupon) {
          const notGetSuitCoupon = buyerCoupon.getSuitableCoupon(tPrice);
          setCanPayCoupon(notGetSuitCoupon);
        } else {
          setCanPayCoupon(undefined);
        }
      } else if (coupon) {
        setCanPayCoupon(undefined);
      }
    }
  }, [ticket, coupon, canUseList]);
  return {
    canUseCouponList: canUseList,
    unUseCouponList: unUseList,
    canPayCoupon,
    setCanPayCoupon,
    coupons,
    coupon
  };
};
export default useCouponList;